import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { initDevicesData, INIT_DEVICES_FAIL, GET_DEVICE_DETAIL_FAIL } from '../../actions/dashboard/index';
import { forwardLogin } from '../../actions/login/index';
import HoodList from '../../components/dashboard/HoodList';
import Loading from '../../components/common/Loading';

class HoodListPage extends Component {
  renderHoodList = () => {
    const { loading } = this.props;

    let displayList;
    if (loading) {
      displayList = <Loading loading={loading}></Loading>;
    } else {
      displayList = <HoodList></HoodList>;
    }

    return (
      <div className='custom-list device-list'>
        {displayList}
      </div>
    )
  }

  componentDidMount() {
    const { idToken, initDevicesData, devices } = this.props;
    if (devices.length === 0) {
      if (idToken) {
        initDevicesData(idToken);
      }      
    }
  }
  
  componentDidUpdate (prevProps, prevState, snapshot) {
    const { forwardLogin, status, history } = this.props;
    if (prevProps.status !== status) {
      if (status === INIT_DEVICES_FAIL || status === GET_DEVICE_DETAIL_FAIL) {
        forwardLogin("Connect timeout, please relogin.");
        history.push("/Login");
      }
    }
  }

  render() {
    return this.renderHoodList();
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    idToken: state.logindReducers.idToken,
    status: state.dashboardReducers.status,
    devices: state.dashboardReducers.devices,
    loading: state.dashboardReducers.loading
  }
}

export default withRouter(connect(
  mapStateToProps, 
  { forwardLogin, initDevicesData }
)(HoodListPage))
